import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ProviderCreatePage } from '@/features/ai/llm/llm-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouveau fournisseur de la passerelle LLM. */
export const Route = createFileRoute('/$tenant/llm/providers/new')({ component: ProviderCreateRoute });

function ProviderCreateRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="llmGateway" crumbs={[{ label: t('nav.items.llmGateway') }]}>
      <ProviderCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
